<template>
  <div class="flex mx-3 border-b border-[#E6E6E6]">
    <div
      data-testid="my-calendar.task-table-tab.all-tab"
      :class="['switch-tab', { active: activeFilterTab === 'all' }]"
      @click="switchTab('all')"
      @mouseenter="hoverTab = 'all'"
      @mouseleave="hoverTab = ''"
    >
      <img :src="getIcon('all')" alt="all" />
      <span>All</span>
    </div>
    <div
      v-if="activeTaskTab === 'myTasks'"
      data-testid="my-calendar.task-table-tab.today-tab"
      :class="['switch-tab', { active: activeFilterTab === 'today' }]"
      @click="switchTab('today')"
      @mouseenter="hoverTab = 'today'"
      @mouseleave="hoverTab = ''"
    >
      <img :src="getIcon('today')" alt="today" />
      <span>Today</span>
    </div>
    <div
      v-if="activeTaskTab === 'myTasks'"
      data-testid="my-calendar.task-table-tab.upcoming-tab"
      :class="['switch-tab', { active: activeFilterTab === 'upcoming' }]"
      @click="switchTab('upcoming')"
      @mouseenter="hoverTab = 'upcoming'"
      @mouseleave="hoverTab = ''"
    >
      <img :src="getIcon('upcoming')" alt="upcoming" />
      <span>Upcoming</span>
    </div>
    <div
      data-testid="my-calendar.task-table-tab.completed-tab"
      :class="['switch-tab', { active: activeFilterTab === 'completed' }]"
      @click="switchTab('completed')"
      @mouseenter="hoverTab = 'completed'"
      @mouseleave="hoverTab = ''"
    >
      <img :src="getIcon('completed')" alt="completed" />
      <span>Completed</span>
    </div>
    <div class="ml-auto w-[218px]">
      <SingleSelector
        data-testid="my-calendar.task-table-tab.sort-by-select"
        class="task-sortby" 
        placeholder="Sort By"
        :options="sortOptions"
        size="medium"
        placement="bottom-end"
        :model-value="sortOrder"
        @update:model-value="handleSortChange"
        />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { sortOptions } from '@/views/my-calendar/mock-data';

const emit = defineEmits(['switch-tab']);
const { activeTaskTab } = defineProps(['activeTaskTab'])
const activeFilterTab = ref('all');
const hoverTab = ref('');
const sortOrder = ref('due-desc')

const handleSortChange = (value) => {
  sortOrder.value = value
  emit('sort-change', value);
}


function switchTab(tab) {
  emit('switch-tab', tab);
  activeFilterTab.value = tab;
}

function getIcon(tab) {
  // tab: 'all' | 'today' | 'upcoming' | 'completed'
  const map = {
    all: 'all',
    today: 'sun',
    upcoming: 'dotted-circle',
    completed: 'done',
  }
  if (activeFilterTab.value === tab) {
    return require(`@/assets/my-calendar/task/blue-${map[tab]}.svg`);
  }
  if (hoverTab.value === tab) {
    return require(`@/assets/my-calendar/task/hover-${map[tab]}.svg`);
  }
  return require(`@/assets/my-calendar/task/gray-${map[tab]}.svg`);
}
</script>

<style scoped>
.switch-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 16px;
  cursor: pointer;
  color: #666666;
  font-weight: 500;
}
.switch-tab:hover {
  color: #81B0E1;
}
.switch-tab.active {
  color: #5587BC;
  border-bottom: 1px solid #5587BC;
}
.task-sortby :deep(.el-select__wrapper) {
  border: none !important;
  box-shadow: none !important;
}
</style>